import { FrameStack } from '@klarna/bubble-ui';
import React from 'react';
import styled from 'styled-components';
import ErrorBanner from '../ErrorBanner';
import ApiKeyInstructions from './ApiKeyInstructions';
import ClientKeyInstructions from './ClientKeyInstructions';
import PluginDocInstructions from './PluginDocInstructions';
const MainContainer = styled.div.withConfig({ displayName: "MainContainer", componentId: "sc-1cw1nd3" }) `
  margin: 40px 0 0 0;
  position: relative;
  left: -16px;
`;
export default function Instructions() {
    return (React.createElement(MainContainer, null,
        React.createElement(FrameStack, null,
            React.createElement(ErrorBanner, null),
            React.createElement(ApiKeyInstructions, null),
            React.createElement(ClientKeyInstructions, null),
            React.createElement(PluginDocInstructions, null))));
}
